import {
  daysInMonth,
  formatDate,
} from "@frontend/components/atoms/DatePicker/dateMath";

export type CalendarMonth = {
  year: number;
  month: number; // 0-11
};

export function parseMonth(
  value: string | null | undefined,
): CalendarMonth | null {
  if (!value) {
    return null;
  }

  const match = /^(\d{4})-(\d{2})$/.exec(value);

  if (!match) {
    return null;
  }

  const month = Number(match[2]) - 1;

  if (month < 0 || month > 11) {
    return null;
  }

  return { year: Number(match[1]), month };
}

export function formatMonth({ year, month }: CalendarMonth): string {
  return [
    String(year).padStart(4, "0"),
    String(month + 1).padStart(2, "0"),
  ].join("-");
}

export function thisMonth(): CalendarMonth {
  const now = new Date();

  return { year: now.getFullYear(), month: now.getMonth() };
}

export function compareMonth(a: CalendarMonth, b: CalendarMonth): number {
  if (a.year !== b.year) {
    return a.year - b.year;
  }

  return a.month - b.month;
}

/** First and last day of the month, as `"YYYY-MM-DD"` strings. */
export function monthBounds({ year, month }: CalendarMonth): {
  start: string;
  end: string;
} {
  return {
    start: formatDate({ year, month, day: 1 }),
    end: formatDate({ year, month, day: daysInMonth(year, month) }),
  };
}
